import useSelectWallet from './use-select-wallet';

export default function (walletsCollection) {
  const wallet = useSelectWallet(walletsCollection);
  return Math.round(((wallet || {}).balance || 0) * 100) / 100;
}
